<template>
    <v-container class="ma-0 pa-0">
        <div class="buttons-home-container">
            <div
                v-for="(post, index) in getPostsToShow"
                :key="post.id"
                class="buttons-home"

                :style="(index <= getIndexShowPost || post.attributes.url === 'awards' ? 'opacity: 1 ' : 'opacity: 0.3 ')"

                @click="clickButton(post, index)"
            >
                <!--              box-shadow: 3px 3px 3px grey;-->
                <base-card
                    :class="'rounded-xl base-card-buttons '+(post.attributes.url === 'purposes' ? 'button-border-mark' : '')"
                    style="'width: 100%; height: 100%; '"
                >
                    <div
                        v-if="post.attributes.url === 'awards'"
                        class="pt-3"
                        style="display: flex; flex-flow: column wrap; align-content: center; text-align: center"
                    >
                        <span
                            v-if="competitionIsEnded"
                            class="weHaveWinners"
                        >
                            YA TENEMOS
                        </span>
                        <strong
                            v-else
                            class="winnersComingSoon"
                        >
                            PRÓXIMAMENTE
                        </strong>

                        <span
                            v-if="getTimeLeft"
                            class="text-center text-awards"
                            v-html="getTimeLeft"
                        />
                    </div>
                    <div style="display:flex; flex-wrap:wrap;  max-height: 80%">
                        <v-img
                            style="border-radius: 24px 24px 30px 5px"
                            width="100%"
                            contain
                            :src="getImageRoute + post.attributes.image"
                            :min-height="competitionIsEnded ? '80px' : '55px'"
                        >
                            <template v-slot:placeholder>
                                <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                >
                                    <v-progress-circular
                                        indeterminate
                                        color="blue lighten-5"
                                    />
                                </v-row>
                            </template>
                        </v-img>
                    </div>
                    <v-card-actions
                        class="pa-2 pa-sm-4 d-flex justify-space-between"
                    >
                        <!--                        <div class="d-flex align-center">
                <span>esto es una prueba</span>
            </div>-->
                        <v-card-subtitle
                            class="pa-0 "
                            style="width: 100%;"
                        >
                            <div class="d-flex justify-center">
                                <span
                                    class="text-center"
                                >{{ post.attributes.title }}</span>
                            </div>
                        </v-card-subtitle>
                    </v-card-actions>
                </base-card>
            </div>
        </div>

        <slot />
    </v-container>
</template>

<script>
// import axios from '@/plugins/axios';
import { mapGetters } from 'vuex'

export default {
    name: 'Posts',
    data: function () {
        return {
            dateNow: Date.now(),
            // dateEnd: new Date("2021/09/30 23:59:59"),
            refreshIntervalId: null
        }
    },
    created() {

    },
    mounted() {
        this.$store.dispatch('cache/loadDateCloseCompetition');

        var self = this;
        this.refreshIntervalId = setInterval(function () {
            // console.log('setInterval HOME ');

            if (self.getDateCloseCompetition && self.dateNow > self.getDateCloseCompetition) {
                clearInterval(self.refreshIntervalId);
            }

            self.dateNow = Date.now();
        }, 1000);
    },
    beforeDestroy() {
        if (this.refreshIntervalId) {
            clearInterval(this.refreshIntervalId);
        }
    },
    methods: {
        clickButton(post, index) {
            if (index <= this.getIndexShowPost || post.attributes.url === 'awards') {
                post.attributes.body ? this.$router.push('/app/pages/post/' + post.attributes.url) : this.$router.push('/app/pages/' + post.attributes.url);
            } else {
                this.$store.dispatch('snackbar/error', this.$t('home.optionLocked'));
            }
        }
    },
    computed: {
        ...mapGetters('cache', ['getPostsOrdered', 'getDateCloseCompetition']),
        ...mapGetters(['getIndexShowPost']),
        ...mapGetters('statistics', ['getMyLikes', 'getCoinsWhithoutSpend']),
        getTimeLeft() {
            if (!this.getDateCloseCompetition || this.dateNow > this.getDateCloseCompetition) return ""
            return this.dateHelper.showDiffForHumans(this.dateNow, this.getDateCloseCompetition, true);
        },
        competitionIsEnded() {
            return (this.getDateCloseCompetition && this.dateNow > this.getDateCloseCompetition);
        },
        getPostsToShow() {
            return this.getPostsOrdered.filter(post => {
                if (post.attributes.url !== "juegoFinal") return true;
                else return this.getMyLikes && this.getCoinsWhithoutSpend === 0;
            })
        },
        getImageRoute() {
            return process.env.VUE_APP_API_ENDPOINT + 'imagesSimple?filename=posts/images/'
        }
    }

}
</script>

<style scoped>

.buttons-home-container{
  display: flex;
  flex-flow: row wrap;
  justify-content: center;

  /*border: 1px red solid;*/
}

.buttons-home{
  width: 6.875rem;
  height: 12rem;

  /*border: 1px red solid;*/
  padding: 7px;

  cursor: pointer;
}

.base-card-buttons:hover{
  border: 1px #006ff5 solid !important;
}

.button-border-mark{
  border: 3px #46d5ab solid !important;
}

@media (min-width: 570px) {
  .buttons-home{
    width: 11.5rem;
    height: 14.5rem;

    /*border: 1px red solid;*/
    padding: 12px;
  }

  .weHaveWinners{
    font-size: 1.3em !important;
  }

  .winnersComingSoon{
    font-size: 1.0em !important;
  }

}

.text-awards{
  font-size: 0.9em;
  line-height: 1.2;
  color: #46d5ab;
}

.weHaveWinners{
  font-size: 0.8em;
  color: #46d5ab;
}
.winnersComingSoon{
  font-size: 0.6em;
  color: black;
}

</style>
